export default __webpack_public_path__ + "static/media/KanandaFerreira_01.a6e8bbce.jpg";